import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const Business: AppRouteModule = {
  path: '/noticeManage',
  name: 'NoticeManage',
  identify: 'noticeManage',
  component: LAYOUT,
  redirect: '/noticeManage/notice',
  meta: {
    icon: 'icon-park-outline:volume-notice',
    title: '通知管理',
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    {
      path: 'notice',
      name: 'Notice',
      identify: 'noticeManage',
      component: () => import('@/views/noticeManage/notice/index.vue'),
      meta: {
        title: '消息通知',
        hideMenu: true,
        hideTab: true,
        roles: [RoleEnum.OFFLINE],
        currentActiveMenu: '/noticeManage',
      },
    },
    {
      path: 'noticeAdd',
      name: 'NoticeAdd',
      identify: 'noticeManage',
      component: () => import('@/views/noticeManage/notice/add.vue'),
      meta: {
        title: '新建通知',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/noticeManage',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'noticeEdit',
      name: 'NoticeEdit',
      identify: 'noticeManage',
      component: () => import('@/views/noticeManage/notice/edit.vue'),
      meta: {
        title: '编辑通知',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/noticeManage',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'noticeDetails',
      name: 'NoticeDetails',
      identify: 'noticeManage',
      component: () => import('@/views/noticeManage/notice/details.vue'),
      meta: {
        title: '通知详情',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/noticeManage',
        roles: [RoleEnum.OFFLINE],
      },
    },
  ],
};

export default Business;
